<template>
  <div class="container">
    <content-title :nav="nav"></content-title>
    <el-form :inline="true">
      <el-form-item label="所属合作商">
        <cooperatorSelect
          :clearable="true"
          :condition="{ type: 'shop' }"
          :coopid.sync="query.coop_id"
        ></cooperatorSelect>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="add">新增规则</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="effectiveShow = true"
          >查询生效规则</el-button
        >
      </el-form-item>
    </el-form>

    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #coop_id="{ row }">
        <span v-if="row.coop_id">{{ row.coop_name || row.coop_id }}</span>
        <el-tag v-else size="small">平台默认</el-tag>
      </template>
      <template #plan_type="{ row }">
        <el-tag size="small" v-if="row.plan_type === 1">商会版</el-tag>
        <el-tag size="small" type="warning" v-else-if="row.plan_type === 2"
          >会员版</el-tag
        >
        <span v-else>-</span>
      </template>
      <template #order_fee_rate="{ row }">
        {{ row.order_fee_rate ? (row.order_fee_rate * 100).toFixed(2) + "%" : "-" }}
      </template>
      <template #ratio="{ row }">
        <div>套餐·合伙人 {{ ratioText(row.package_partner_ratio) }}</div>
        <div>套餐·秘书长 {{ ratioText(row.package_secretary_ratio) }}</div>
        <div>服务费·合伙人 {{ ratioText(row.service_fee_partner_ratio) }}</div>
        <div>服务费·秘书长 {{ ratioText(row.service_fee_secretary_ratio) }}</div>
      </template>
      <template #handle="{ row }">
        <el-button size="small" type="success" @click="update(row)"
          >编辑</el-button
        >
        <el-button size="small" type="danger" @click="del(row)">删除</el-button>
      </template>
    </auto-table>

    <!-- 新增编辑规则 -->
    <el-dialog
      :title="form.id ? '编辑规则' : '新增规则'"
      :visible.sync="editShow"
      width="50%"
    >
      <el-form :model="form" :rules="rules" ref="form" label-width="130px">
        <el-form-item label="合作商覆盖" prop="coop_id">
          <cooperatorSelect
            :clearable="true"
            :condition="{ type: 'shop' }"
            :coopid.sync="form.coop_id"
            :info="coopName"
          ></cooperatorSelect>
          <div>不选则为平台默认规则</div>
        </el-form-item>
         <el-form-item label="套餐类型" prop="plan_type">
          <el-select
            v-model="form.plan_type"
            placeholder="选择套餐类型"
            clearable
          >
            <el-option label="商会版" :value="1"></el-option>
            <el-option label="会员版" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年费(元/年)" required prop="annual_fee">
          <el-input-number
            v-model="form.annual_fee"
            :min="0"
            :precision="2"
            :controls="false"
            placeholder="0=免缴"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="押金(元)" required prop="deposit">
          <el-input-number
            v-model="form.deposit"
            :min="0"
            :precision="2"
            :controls="false"
            placeholder="0=免押"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="订单服务费率" prop="order_fee_rate">
          <el-input-number
            v-model="form.order_fee_rate"
            :min="0"
            :max="1"
            :precision="4"
            :controls="false"
            placeholder="如0.05表示5%"
          ></el-input-number>
          <div>小数表示，如0.05表示5%，本期仅展示</div>
        </el-form-item>
        <el-form-item label="单笔最低服务费" prop="order_min_fee">
          <el-input-number
            v-model="form.order_min_fee"
            :min="0"
            :precision="2"
            :controls="false"
            placeholder="元"
          ></el-input-number>
          <div>本期仅展示</div>
        </el-form-item>
       
        <el-form-item label="套餐分成-合伙人" prop="package_partner_ratio">
          <el-input-number
            v-model="form.package_partner_ratio"
            :min="0"
            :max="1"
            :precision="2"
            :controls="false"
            placeholder="如0.30表示30%"
          ></el-input-number>
          <div>小数表示，商会版0.30/会员版0.20</div>
        </el-form-item>
        <el-form-item label="套餐分成-秘书长" prop="package_secretary_ratio">
          <el-input-number
            v-model="form.package_secretary_ratio"
            :min="0"
            :max="1"
            :precision="2"
            :controls="false"
            placeholder="如0.30表示30%"
          ></el-input-number>
          <div>小数表示，商会版0.00/会员版0.30</div>
        </el-form-item>
        <el-form-item label="服务费分成-合伙人" prop="service_fee_partner_ratio">
          <el-input-number
            v-model="form.service_fee_partner_ratio"
            :min="0"
            :max="1"
            :precision="2"
            :controls="false"
            placeholder="如0.30表示30%"
          ></el-input-number>
          <div>小数表示，如0.30表示30%</div>
        </el-form-item>
        <el-form-item label="服务费分成-秘书长" prop="service_fee_secretary_ratio">
          <el-input-number
            v-model="form.service_fee_secretary_ratio"
            :min="0"
            :max="1"
            :precision="2"
            :controls="false"
            placeholder="如0.30表示30%"
          ></el-input-number>
          <div>小数表示，如0.30表示30%</div>
        </el-form-item>
        <el-form-item label="生效时间" required prop="effective_at">
          <el-date-picker
            v-model="form.effective_at"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择生效时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="失效时间" prop="expire_at">
          <el-date-picker
            v-model="form.expire_at"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="不填则长期有效"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            type="textarea"
            :rows="3"
            v-model="form.remark"
            placeholder="备注"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editShow = false">取 消</el-button>
        <el-button type="primary" :loading="loading" @click="save"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- 查询生效规则 -->
    <el-dialog title="查询生效规则" :visible.sync="effectiveShow" width="45%">
      <el-form :inline="true">
        <el-form-item label="店铺ID">
          <el-input
            v-model="effective_shop_id"
            placeholder="店铺ID"
            style="width: 180px"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="effectiveLoading" @click="getEffective"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
      <el-descriptions :column="2" border v-if="effective.id || effective.source">
        <el-descriptions-item label="规则来源">
          <el-tag size="small" v-if="effective.source === 'PLATFORM'"
            >平台默认</el-tag
          >
          <el-tag size="small" type="warning" v-else-if="effective.source === 'COOP'"
            >合作商覆盖</el-tag
          >
          <el-tag size="small" type="info" v-else>未配置规则</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="规则ID">{{
          effective.id || "-"
        }}</el-descriptions-item>
        <el-descriptions-item label="年费(元/年)">{{
          effective.annual_fee
        }}</el-descriptions-item>
        <el-descriptions-item label="押金(元)">{{
          effective.deposit
        }}</el-descriptions-item>
        <el-descriptions-item label="订单服务费率">{{
          effective.order_fee_rate
            ? (effective.order_fee_rate * 100).toFixed(2) + "%"
            : "-"
        }}</el-descriptions-item>
        <el-descriptions-item label="单笔最低服务费">{{
          effective.order_min_fee || "-"
        }}</el-descriptions-item>
        <el-descriptions-item label="套餐类型">
          <el-tag size="small" v-if="effective.plan_type === 1">商会版</el-tag>
          <el-tag
            size="small"
            type="warning"
            v-else-if="effective.plan_type === 2"
            >会员版</el-tag
          >
          <span v-else>-</span>
        </el-descriptions-item>
        <el-descriptions-item label="套餐分成-合伙人">{{
          ratioText(effective.package_partner_ratio)
        }}</el-descriptions-item>
        <el-descriptions-item label="套餐分成-秘书长">{{
          ratioText(effective.package_secretary_ratio)
        }}</el-descriptions-item>
        <el-descriptions-item label="服务费分成-合伙人">{{
          ratioText(effective.service_fee_partner_ratio)
        }}</el-descriptions-item>
        <el-descriptions-item label="服务费分成-秘书长" :span="2">{{
          ratioText(effective.service_fee_secretary_ratio)
        }}</el-descriptions-item>
        <el-descriptions-item label="生效时间">{{
          effective.effective_at || "-"
        }}</el-descriptions-item>
        <el-descriptions-item label="失效时间">{{
          effective.expire_at || "长期有效"
        }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer" class="dialog-footer">
        <el-button @click="effectiveShow = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cooperatorSelect from "@/components/select/cooperatorSelect.vue";
import { ObjectChangedValue } from "@/js/utils.js";

export default {
  components: {
    cooperatorSelect,
  },
  data() {
    return {
      nav: { firstNav: "合作商管理", secondNav: "店铺收费规则" },
      DataList: [],
      Total: 0,
      query: {
        coop_id: "",
      },
      Option: [
        { name: "规则ID", value: "id" },
        { name: "合作商", value: "coop_id", type: "custom" },
        { name: "年费(元/年)", value: "annual_fee" },
        { name: "押金(元)", value: "deposit" },
        { name: "套餐类型", value: "plan_type", type: "custom" },
        { name: "订单服务费率", value: "order_fee_rate", type: "custom" },
        { name: "单笔最低服务费", value: "order_min_fee" },
        { name: "分成比例", value: "ratio", type: "custom", width: "150px" },
        { name: "生效时间", value: "effective_at" },
        { name: "失效时间", value: "expire_at" },
        { name: "备注", value: "remark" },
        { name: "操作", value: "handle", type: "custom", width: "160px" },
      ],
      form: {},
      temp: {},
      coopName: "",
      rules: {
        annual_fee: [
          { required: true, message: "请填写年费金额", trigger: "blur" },
        ],
        deposit: [{ required: true, message: "请填写押金金额", trigger: "blur" }],
        effective_at: [
          { required: true, message: "请选择生效时间", trigger: "change" },
        ],
      },
      editShow: false,
      loading: false,
      effectiveShow: false,
      effectiveLoading: false,
      effective_shop_id: "",
      effective: {},
    };
  },

  mounted() {
    this.getList(1);
  },

  methods: {
    ratioText(v) {
      if (v === null || v === undefined || v === "") return "-";
      return (v * 100).toFixed(2) + "%";
    },
    add() {
      this.form = {
        annual_fee: 0,
        deposit: 0,
      };
      this.temp = {};
      this.coopName = "";
      this.editShow = true;
    },
    update(row) {
      this.temp = Object.assign({}, row);
      this.form = Object.assign({}, row);
      this.coopName = row.coop_name || row.coop_id || "";
      this.editShow = true;
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let data;
          if (this.form.id) {
            data = ObjectChangedValue(this.temp, this.form);
            if (Object.keys(data).length == 0) {
              this.$message("没有修改数据，无需更新");
              return;
            }
            data.id = this.form.id;
          } else {
            data = this.form;
          }
          this.loading = true;
          this.$axios({
            url: this.form.id ? "/user/shopFeeRule/update" : "/user/shopFeeRule/save",
            method: "post",
            data,
          })
            .then((res) => {
              this.$notify({
                message: this.form.id ? "更新成功" : "新增成功",
                duration: 2000,
                type: "success",
              });
              this.editShow = false;
              this.loading = false;
              this.getList(1);
            })
            .catch(() => {
              this.loading = false;
            });
        }
      });
    },
    del(row) {
      this.$confirm("确定删除该收费规则吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios({
            url: "/user/shopFeeRule/delete",
            params: {
              id: row.id,
            },
            method: "post",
          }).then((res) => {
            this.$notify({
              message: "删除成功",
              duration: 2000,
              type: "success",
            });
            this.getList(1);
          });
        })
        .catch(() => {});
    },
    getEffective() {
      if (!this.effective_shop_id) {
        this.$message("请输入店铺ID");
        return;
      }
      this.effectiveLoading = true;
      this.$axios({
        url: "/user/shopFeeRule/effective",
        params: {
          shop_id: this.effective_shop_id,
        },
      })
        .then((res) => {
          this.effective = res.data.data || {};
          this.effectiveLoading = false;
        })
        .catch(() => {
          this.effectiveLoading = false;
        });
    },
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/user/shopFeeRule/page",
        params: {
          page: page,
          size: 10,
          coop_id: this.query.coop_id || null,
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
